// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__bcRQY","header":"PatientBlock_header__7jO7Q","label":"PatientBlock_label__2irt8","option":"PatientBlock_option__35utt"};